import { MenuItem, Stack, TextField } from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";
import { LabellingCoverageGranularity } from "store/api/generatedApi";

const GranularityOptions: LabellingCoverageGranularity[] = [
  "period",
  "hourly",
  "daily",
  "weekly",
  "monthly",
];

interface CoverageControlsProps {
  granularity: LabellingCoverageGranularity;
  onGranularityChange: (value: LabellingCoverageGranularity) => void;
  gapTolerance: number;
  onGapToleranceChange: (value: number) => void;
}

export const CoverageControls = ({
  granularity,
  onGranularityChange,
  gapTolerance,
  onGapToleranceChange,
}: CoverageControlsProps) => {
  const { t } = useTenantTranslation();

  return (
    <Stack direction="row" spacing={2}>
      <TextField
        select
        label={t("granularity")}
        value={granularity}
        onChange={(e) => {
          onGranularityChange(e.target.value as LabellingCoverageGranularity);
        }}
        size="small"
        sx={{ width: 150 }}
      >
        {GranularityOptions.map((option) => (
          <MenuItem key={option} value={option}>
            {t(option)}
          </MenuItem>
        ))}
      </TextField>
      <TextField
        type="number"
        label={t("allowedCoverageGap")}
        value={gapTolerance}
        onChange={(e) => {
          onGapToleranceChange(Number(e.target.value));
        }}
        size="small"
        sx={{ width: 200 }}
        slotProps={{ htmlInput: { min: 0, max: 300 } }}
      />
    </Stack>
  );
};
